import { AdvertisementPosition, AdvertisementSlotResponse, AdvertisementType } from '../types';

export const ADVERTISEMENT_INTENT_SLOT_ID_KEY = 'pendingAdvertisementSlotId';
export const ADVERTISEMENT_INTENT_OPEN_KEY = 'pendingAdvertisementOpenCreate';

export function normalizeAdvertisementPagePath(pagePath?: string): string {
  const normalized = (pagePath || '').trim() || '/';
  if (normalized === '/bootcamps') return '/events';
  return normalized;
}

export function getAdvertisementPageAliases(pagePath?: string): string[] {
  const normalized = normalizeAdvertisementPagePath(pagePath);
  if (normalized === '/events') return ['/events', '/bootcamps'];
  return [normalized];
}

export function slotMatchesAdvertisementArea(
  slot: Pick<AdvertisementSlotResponse, 'pagePath' | 'type' | 'position'>,
  pagePath: string,
  type: AdvertisementType,
  position?: AdvertisementPosition
): boolean {
  return (
    getAdvertisementPageAliases(pagePath).includes(slot.pagePath) &&
    slot.type === type &&
    (position === undefined || slot.position === position)
  );
}

export function getAdvertisementPageLabel(pagePath: string): string {
  const normalized = normalizeAdvertisementPagePath(pagePath);
  const labels: Record<string, string> = {
    '/': 'Ana Sayfa',
    '/mentor-search': 'Mentor Arama',
    '/mentees': 'Mentee Listesi',
    '/events': 'Etkinlikler',
    '/job-postings': 'Is Ilanlari',
    '/categories': 'Kategoriler',
  };
  return labels[normalized] || normalized;
}

export function getAdvertisementPositionLabel(position: AdvertisementPosition): string {
  const labels: Record<AdvertisementPosition, string> = {
    [AdvertisementPosition.Top]: 'Ust',
    [AdvertisementPosition.Inline]: 'Satir Ici',
    [AdvertisementPosition.Bottom]: 'Alt',
    [AdvertisementPosition.Sidebar]: 'Kenar',
  };
  return labels[position] || String(position);
}

export function getAdvertisementPositionValue(position: 'top' | 'bottom' | 'inline' | 'sidebar'): AdvertisementPosition {
  switch (position) {
    case 'top':
      return AdvertisementPosition.Top;
    case 'inline':
      return AdvertisementPosition.Inline;
    case 'bottom':
      return AdvertisementPosition.Bottom;
    case 'sidebar':
      return AdvertisementPosition.Sidebar;
    default:
      return AdvertisementPosition.Inline;
  }
}

export function storeAdvertisementIntent(slotId: number): void {
  localStorage.setItem(ADVERTISEMENT_INTENT_SLOT_ID_KEY, String(slotId));
  localStorage.setItem(ADVERTISEMENT_INTENT_OPEN_KEY, '1');
}

